var _rect, _rect2, _rect3, _rect4, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHideNavbar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#181818"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1000,
    transform: "translate(-245 -62)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -245,
    y: -62,
    width: 315,
    height: 1000,
    fill: "#1FBFE5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 40,
    height: 40,
    rx: 10,
    transform: "matrix(-1 0 0 1 40 0)",
    fill: "#F6F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1959 20.4716L18.1955 26.4713C18.3206 26.5964 18.4903 26.6666 18.6672 26.6666C18.8441 26.6666 19.0137 26.5964 19.1388 26.4713C19.2639 26.3462 19.3342 26.1765 19.3342 25.9996C19.3342 25.8227 19.2639 25.6531 19.1388 25.528L14.2766 20.6666H27.3334C27.5102 20.6666 27.6797 20.5964 27.8047 20.4714C27.9298 20.3463 28 20.1768 28 20C28 19.8232 27.9298 19.6536 27.8047 19.5286C27.6797 19.4036 27.5102 19.3333 27.3334 19.3333H14.2766L19.1388 14.472C19.2639 14.3469 19.3342 14.1772 19.3342 14.0003C19.3342 13.8234 19.2639 13.6538 19.1388 13.5287C19.0137 13.4036 18.8441 13.3333 18.6672 13.3333C18.4903 13.3333 18.3206 13.4036 18.1955 13.5287L12.1959 19.5283C12.1339 19.5903 12.0847 19.6638 12.0512 19.7447C12.0176 19.8256 12.0004 19.9124 12.0004 20C12.0004 20.0876 12.0176 20.1743 12.0512 20.2553C12.0847 20.3362 12.1339 20.4097 12.1959 20.4716Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideNavbar);
export default __webpack_public_path__ + "static/media/hide-navbar.c49b245eaa886bd34cbf76c15fda4ca3.svg";
export { ForwardRef as ReactComponent };